import React from 'react';
import './css/bootstrap.css'
import './css/timeline.css'
import './css/gl.css';
import 'swiper/css';
import 'swiper/css/pagination';
import ScMain from "./page/ScMain";

import "bootstrap-icons/font/bootstrap-icons.css";

import './assets/vendor/boxicons/css/boxicons.min.css';
import './assets/vendor/glightbox/css/glightbox.min.css';
import './assets/vendor/remixicon/remixicon.css';

function App() {
  return (
      <ScMain />
  );
}

export default App;
